import { render, staticRenderFns } from "./accidentVehicle.vue?vue&type=template&id=bb49fd88&scoped=true"
import script from "./accidentVehicle.vue?vue&type=script&lang=js"
export * from "./accidentVehicle.vue?vue&type=script&lang=js"
import style0 from "./accidentVehicle.vue?vue&type=style&index=0&id=bb49fd88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb49fd88",
  null
  
)

export default component.exports